const CF_IMAGE_BASE = "https://imagedelivery.net"

/** Shared Cloudflare Images delivery hash (server runtime). */
const CF_ACCOUNT_HASH = process.env.CLOUDFLARE_IMAGES_ACCOUNT_HASH?.trim() || ""

function assertCfAccountHash(): string {
  const hash = CF_ACCOUNT_HASH?.trim() ?? ""
  if (!hash) {
    throw new Error(
      "Missing Cloudflare Images account hash. Set CLOUDFLARE_IMAGES_ACCOUNT_HASH.",
    )
  }
  return hash
}

export const cfImage = (id: string, variant = "public") => {
  const hash = assertCfAccountHash()
  const imageId = id.trim()
  const seg = variant.trim() || "public"
  return `${CF_IMAGE_BASE}/${hash}/${imageId}/${seg}`
}

export const cfImageWithHash = (
  hash: string,
  id: string,
  variant = "public",
) => {
  const hashTrim = hash.trim()
  if (!hashTrim) return ""
  const imageId = id.trim()
  const seg = variant.trim() || "public"
  return `${CF_IMAGE_BASE}/${hashTrim}/${imageId}/${seg}`
}
